import React, { useEffect, useState } from 'react';
import api from '../api';
import './estilodash.css';

const ClientesList = () => {
  const [clientes, setClientes] = useState([]);
  const [licencas, setLicencas] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);

  const [busca, setBusca] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);

  const [apiKey] = useState('abc1234'); // mantido se precisar no futuro

  // FILTROS
  const [filtroStatus, setFiltroStatus] = useState('todos'); // todos | ativos | inativos
  const [filtroIsento, setFiltroIsento] = useState('todos'); // todos | isentos | nao-isentos
  const [filtroPlano, setFiltroPlano] = useState('todos'); // todos | <id do plano>

  useEffect(() => {
    carregarTudo();
  }, []);

  const carregarTudo = async () => {
    try {
      setCarregando(true);
      setErro(null);

      const [respClientes, respLicencas, respPlanos] = await Promise.all([
        api.get('/api/clientes'),
        api.get('/api/licencas'),
        api.get('/api/planos-ativos'),
      ]);

      setClientes(respClientes.data || []);
      setLicencas(respLicencas.data || []);
      setPlanos(respPlanos.data || []);

      // se vier um clienteFiltroId do ListarLicencas, aplica no filtro
      const filtroId = localStorage.getItem('clienteFiltroId');
      if (filtroId) {
        const cli = (respClientes.data || []).find(
          (c) => String(c.id) === filtroId
        );
        if (cli) {
          setBusca(cli.nome || filtroId);
        }
        localStorage.removeItem('clienteFiltroId');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      setErro('Erro ao carregar dados. Verifique o login/servidor.');
    } finally {
      setCarregando(false);
    }
  };

  const getPlanoById = (planoId) => {
    if (!planoId) return null;
    return planos.find((p) => Number(p.id) === Number(planoId)) || null;
  };

  const calcularExtras = (cliente) => {
    const plano = getPlanoById(cliente.plano_id);
    const slotsContratados = Number(cliente.slots_contratados ?? 0);
    const slotsIncluidos = plano ? Number(plano.slots_inclusos ?? 0) : 0;
    const extras = Math.max(slotsContratados - slotsIncluidos, 0);
    return { slotsContratados, slotsIncluidos, extras };
  };

  const getLicencasCadastradas = (clienteId) => {
    return licencas.filter(
      (lic) => Number(lic.id_cliente) === Number(clienteId)
    ).length;
  };

  const handleAlterarStatus = async (cliente) => {
    const novoStatus = String(cliente.status) === '1' ? '0' : '1';

    if (
      !window.confirm(
        `Deseja realmente ${
          novoStatus === '1' ? 'ATIVAR' : 'DESATIVAR'
        } o cliente "${cliente.nome}"?`
      )
    ) {
      return;
    }

    try {
      await api.put(`/api/clientes/${cliente.id}/status`, {
        status: novoStatus,
      });
      carregarTudo();
    } catch (error) {
      console.error('Erro ao alterar o status do cliente:', error);
      alert('Erro ao alterar o status do cliente.');
    }
  };

  const handleToggleIsento = async (cliente) => {
    const novoIsento = String(cliente.isento) === '1' ? '0' : '1';

    if (
      !window.confirm(
        `Deseja marcar o cliente "${cliente.nome}" como ${
          novoIsento === '1' ? 'ISENTO' : 'NÃO ISENTO'
        }?`
      )
    ) {
      return;
    }

    try {
      await api.put(`/api/clientes/${cliente.id}/isento`, {
        isento: novoIsento,
      });
      carregarTudo();
    } catch (error) {
      console.error('Erro ao atualizar isento do cliente:', error);
      alert('Erro ao atualizar isento do cliente.');
    }
  };

  const handleAlterarSlots = async (cliente) => {
    const atual = cliente.slots_contratados ?? 2;

    const entrada = window.prompt(
      `Informe o número de SLOTS contratados para o cliente "${cliente.nome}":`,
      atual
    );

    if (entrada === null) return; // cancelou

    const slots = parseInt(entrada, 10);
    if (isNaN(slots) || slots < 1) {
      alert('Valor inválido. Informe um número inteiro maior ou igual a 1.');
      return;
    }

    try {
      await api.put(`/api/clientes/${cliente.id}/slots`, {
        slots_contratados: slots,
      });
      carregarTudo();
    } catch (error) {
      console.error('Erro ao atualizar slots contratados do cliente:', error);
      alert('Erro ao atualizar slots contratados.');
    }
  };

  const handleEditarCliente = (cliente) => {
    setClienteSelecionado({ ...cliente });
  };

  const handleCancelarEdicao = () => {
    setClienteSelecionado(null);
  };

  const handleSalvarEdicao = async () => {
    if (!clienteSelecionado) return;

    // validação simples do dia de vencimento antes de enviar
    let diaVenc = clienteSelecionado.dia_vencimento;

    if (diaVenc !== undefined && diaVenc !== null && diaVenc !== '') {
      diaVenc = parseInt(diaVenc, 10);
      if (isNaN(diaVenc) || diaVenc < 1 || diaVenc > 28) {
        alert('Dia de vencimento inválido. Informe um número entre 1 e 28.');
        return;
      }
    } else {
      diaVenc = undefined; // não envia = backend mantém o valor atual
    }

    try {
      await api.put(`/api/clientes/${clienteSelecionado.id}`, {
        nome: clienteSelecionado.nome,
        email: clienteSelecionado.email,
        phone: clienteSelecionado.phone,
        cpf: clienteSelecionado.cpf,
        slots_contratados: clienteSelecionado.slots_contratados,
        dia_vencimento: diaVenc,
      });
      setClienteSelecionado(null);
      carregarTudo();
    } catch (error) {
      console.error('Erro ao salvar o cliente:', error);
      alert('Erro ao salvar o cliente.');
    }
  };

  const handleRemoverCliente = async (id) => {
    if (!window.confirm('Deseja realmente remover este cliente?')) return;

    try {
      await api.delete(`/api/clientes/${id}`);
      carregarTudo();
    } catch (error) {
      console.error('Erro ao remover o cliente:', error);
      alert('Erro ao remover o cliente.');
    }
  };

  // ================== FILTROS ==================

  // 1) Filtro por texto (ID, nome, e-mail, cpf, telefone)
  let clientesFiltrados = clientes.filter((cliente) => {
    if (!busca) return true;
    const termo = busca.toLowerCase();
    return (
      String(cliente.id).includes(termo) ||
      (cliente.nome && cliente.nome.toLowerCase().includes(termo)) ||
      (cliente.email && cliente.email.toLowerCase().includes(termo)) ||
      (cliente.cpf && String(cliente.cpf).toLowerCase().includes(termo)) ||
      (cliente.phone && String(cliente.phone).toLowerCase().includes(termo))
    );
  });

  // 2) Filtro por status (todos | ativos | inativos)
  if (filtroStatus === 'ativos') {
    clientesFiltrados = clientesFiltrados.filter(
      (c) => String(c.status) === '1'
    );
  } else if (filtroStatus === 'inativos') {
    clientesFiltrados = clientesFiltrados.filter(
      (c) => String(c.status) !== '1'
    );
  }

  // 3) Filtro por isento (todos | isentos | nao-isentos)
  if (filtroIsento === 'isentos') {
    clientesFiltrados = clientesFiltrados.filter(
      (c) => String(c.isento) === '1'
    );
  } else if (filtroIsento === 'nao-isentos') {
    clientesFiltrados = clientesFiltrados.filter(
      (c) => String(c.isento) !== '1'
    );
  }

  // 4) Filtro por plano (todos | plano específico)
  if (filtroPlano !== 'todos') {
    clientesFiltrados = clientesFiltrados.filter(
      (c) => Number(c.plano_id) === Number(filtroPlano)
    );
  }

  return (
    <div className="clientes-container">
      <h3>Lista de Clientes</h3>

      {/* Filtros semelhantes ao ListarLicencas */}
      <div className="clientes-filtros">
        <label>
          Buscar:&nbsp;
          <input
            type="text"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            placeholder="ID, nome, e-mail, CPF ou telefone"
            style={{ width: '40ch' }}
          />
        </label>

        <label>
          Status:&nbsp;
          <select
            value={filtroStatus}
            onChange={(e) => setFiltroStatus(e.target.value)}
          >
            <option value="todos">Todos</option>
            <option value="ativos">Ativos</option>
            <option value="inativos">Inativos</option>
          </select>
        </label>

        <label>
          Isento:&nbsp;
          <select
            value={filtroIsento}
            onChange={(e) => setFiltroIsento(e.target.value)}
          >
            <option value="todos">Todos</option>
            <option value="isentos">Isentos</option>
            <option value="nao-isentos">Não isentos</option>
          </select>
        </label>

        <label>
          Plano:&nbsp;
          <select
            value={filtroPlano}
            onChange={(e) => setFiltroPlano(e.target.value)}
          >
            <option value="todos">Todos</option>
            {planos.map((p) => (
              <option key={p.id} value={p.id}>
                {p.nome}
              </option>
            ))}
          </select>
        </label>

        <button onClick={carregarTudo}>Atualizar</button>
      </div>

      {carregando && <p>Carregando dados...</p>}
      {erro && <p style={{ color: 'red' }}>{erro}</p>}

      <table className="clientes-tabela">
        <thead>
          <tr>
            <th>ID</th>
            <th>Cliente</th>
            <th>Plano</th>
            <th>Slots plano</th>
            <th>Slots contratados</th>
            <th>Slots extras</th>
            <th>Licenças</th>
            <th>Isento</th>
            <th>Status</th>
            <th>Vencimento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {clientesFiltrados.map((cliente) => {
            const plano = getPlanoById(cliente.plano_id);
            const { slotsContratados, slotsIncluidos, extras } =
              calcularExtras(cliente);
            const licCadastradas = getLicencasCadastradas(cliente.id);

            let licClass = 'licencas-ok';
            if (licCadastradas > slotsContratados) {
              licClass = 'licencas-estourado';
            } else if (licCadastradas === slotsContratados) {
              licClass = 'licencas-limite';
            }

            const ativo = String(cliente.status) === '1';
            const isento = String(cliente.isento) === '1';

            const emEdicao =
              clienteSelecionado && clienteSelecionado.id === cliente.id;

            return (
              <tr
                key={cliente.id}
                className={ativo ? '' : 'linha-inativa'}
              >
                <td>{cliente.id}</td>

                {/* COLUNA: dados básicos + edição inline */}
                <td>
                  {emEdicao ? (
                    <>
                      <input
                        type="text"
                        value={clienteSelecionado.nome || ''}
                        onChange={(e) =>
                          setClienteSelecionado({
                            ...clienteSelecionado,
                            nome: e.target.value,
                          })
                        }
                        placeholder="Nome"
                      />
                      <input
                        type="text"
                        value={clienteSelecionado.email || ''}
                        onChange={(e) =>
                          setClienteSelecionado({
                            ...clienteSelecionado,
                            email: e.target.value,
                          })
                        }
                        placeholder="E-mail"
                      />
                      <input
                        type="text"
                        value={clienteSelecionado.phone || ''}
                        onChange={(e) =>
                          setClienteSelecionado({
                            ...clienteSelecionado,
                            phone: e.target.value,
                          })
                        }
                        placeholder="Telefone"
                      />
                      <input
                        type="text"
                        value={clienteSelecionado.cpf || ''}
                        onChange={(e) =>
                          setClienteSelecionado({
                            ...clienteSelecionado,
                            cpf: e.target.value,
                          })
                        }
                        placeholder="CPF"
                      />
                    </>
                  ) : (
                    <>
                      <div>
                        <strong>{cliente.nome}</strong>
                      </div>
                      <div className="texto-menor">{cliente.email}</div>
                      {cliente.phone && (
                        <div className="texto-menor">Tel: {cliente.phone}</div>
                      )}
                      {cliente.cpf && (
                        <div className="texto-menor">CPF: {cliente.cpf}</div>
                      )}
                    </>
                  )}
                </td>

                {/* COLUNA: Plano */}
                <td>
                  {plano ? (
                    <>
                      <div>
                        <strong>{plano.nome}</strong>
                      </div>
                      {plano.descricao && (
                        <div className="texto-menor">{plano.descricao}</div>
                      )}
                    </>
                  ) : (
                    <span className="texto-menor">Sem plano</span>
                  )}
                </td>

                <td>{slotsIncluidos}</td>
                <td>{slotsContratados}</td>
                <td className={extras > 0 ? 'texto-alerta' : ''}>{extras}</td>

                {/* COLUNA: Licenças contratadas / cadastradas com cor */}
                <td>
                  <div className={licClass}>
                    Slots contratados: <b>{slotsContratados}</b>
                    <br />
                    Licenças cadastradas: <b>{licCadastradas}</b>
                  </div>
                </td>

                {/* Isento */}
                <td>
                  <span
                    className={
                      isento ? 'badge badge-isento' : 'badge badge-normal'
                    }
                  >
                    {isento ? 'Isento' : 'Normal'}
                  </span>
                </td>

                {/* Status */}
                <td>
                  <span
                    className={
                      ativo ? 'badge badge-ativo' : 'badge badge-inativo'
                    }
                  >
                    {ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </td>

                {/* Vencimento */}
                <td>
                  {emEdicao ? (
                    <input
                      type="number"
                      min={1}
                      max={28}
                      value={clienteSelecionado.dia_vencimento ?? ''}
                      onChange={(e) =>
                        setClienteSelecionado({
                          ...clienteSelecionado,
                          dia_vencimento: e.target.value,
                        })
                      }
                      className="input-pequeno"
                      placeholder="1-28"
                    />
                  ) : (
                    <span className="texto-menor">
                      {cliente.dia_vencimento
                        ? `Dia ${cliente.dia_vencimento}`
                        : '-'}
                    </span>
                  )}
                </td>

                {/* Ações */}
                <td>
                  {emEdicao ? (
                    <>
                      <button
                        className="btn-salvar"
                        onClick={handleSalvarEdicao}
                      >
                        Salvar
                      </button>
                      <button
                        className="btn-cancelar"
                        onClick={handleCancelarEdicao}
                      >
                        Cancelar
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="btn-editar"
                        onClick={() => handleEditarCliente(cliente)}
                      >
                        Editar
                      </button>
                      <button
                        className="btn-remover"
                        onClick={() =>
                          handleRemoverCliente(cliente.id)
                        }
                      >
                        Remover
                      </button>
                      <button
                        className="btn-editar"
                        onClick={() => handleAlterarSlots(cliente)}
                      >
                        Alterar slots
                      </button>
                      <button
                        className="btn-acao"
                        onClick={() => handleToggleIsento(cliente)}
                      >
                        {isento ? 'Remover isenção' : 'Isentar'}
                      </button>
                      <button
                        className={
                          ativo ? 'status-active' : 'status-inactive'
                        }
                        onClick={() => handleAlterarStatus(cliente)}
                      >
                        {ativo ? 'Desativar' : 'Ativar'}
                      </button>
                    </>
                  )}
                </td>
              </tr>
            );
          })}

          {clientesFiltrados.length === 0 && !carregando && (
            <tr>
              <td colSpan={11} style={{ textAlign: 'center' }}>
                Nenhum cliente encontrado.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClientesList;
